<div [formGroup]="this.formGroup" class="mt-{{FIELD_SPACING}}">
  <div class="row">
    <div class="col-md-12">
        <div class="form-label">{{this.label}}<span *ngIf="this.isOptional" class="optional-tag">&nbsp;(optional)</span></div>
    </div>
  </div>
  <div class="row">
    <div class="col col-md-{{columns}}">
        <input 
          id="{{this.propertyId}}"
          class="form-control  mr-2"
          [ngClass]="[this.isInvalid() ? 'is-invalid' : '',  regular ? '' : 'input-box']"
          type="text" 
          maxlength={{this.maxLength}} 
          formControlName="{{this.propertyName}}" 
          mask="000.000.0000">
    </div>
  </div>
  <app-validator-message [formGroup]="this.formGroup" propertyName="{{this.propertyName}}"></app-validator-message>
</div>